<section *ngIf="visits.length" class="orbi-visit-history-card" [attr.aria-label]="title">
  <div class="orbi-visit-history-card__head">
    <span class="material-icons-round orbi-visit-history-card__icon" aria-hidden="true">history</span>
    <h3 class="orbi-visit-history-card__title">{{ title }}</h3>
  </div>

  <div
    *ngFor="let visit of visibleVisits; trackBy: trackByVisit"
    class="orbi-visit-history-card__visit"
    [class.orbi-visit-history-card__visit--single]="isSingle"
  >
    <p *ngIf="dateTimeLine(visit)" class="orbi-visit-history-card__datetime">{{ dateTimeLine(visit) }}</p>

    <p *ngIf="visit.reasonForVisit" class="orbi-visit-history-card__reason">{{ visit.reasonForVisit }}</p>

    <a
      *ngIf="hasMapPreview(visit)"
      class="orbi-visit-history-card__map"
      [href]="mapUrl(visit)"
      target="_blank"
      rel="noopener noreferrer"
      [attr.aria-label]="'View ' + (visit.locationAddress || 'the visit location') + ' on a map'"
    >
      <img
        class="orbi-visit-history-card__map-image"
        [src]="mapPreviewUrl(visit)"
        [width]="mapPreview.width"
        [height]="mapPreview.height"
        loading="lazy"
        alt=""
      />
    </a>

    <p *ngIf="visit.locationAddress" class="orbi-visit-history-card__address">{{ visit.locationAddress }}</p>

    <div *ngIf="canRate(visit)" class="orbi-visit-history-card__rate">
      <a
        class="btn btn-sm btn-min-width orbi-visit-history-card__rate-btn"
        [ngClass]="isSingle ? 'btn-primary' : 'btn-secondary'"
        [href]="rateUrl(visit)"
        target="_blank"
        rel="noopener noreferrer"
        (click)="onRateVisit(visit)"
      >
        <span class="material-icons-round orbi-visit-history-card__rate-icon" aria-hidden="true">thumb_up</span>
        {{ rateLabel }}
      </a>
    </div>
  </div>

  <div *ngIf="hasSeeAll" class="orbi-visit-history-card__see-all">
    <ui-button
      [buttonText]="seeAllLabel"
      rank="primary"
      size="small"
      addClass="orbi-visit-history-card__see-all-btn"
      (handleClick)="onSeeAll()"
    ></ui-button>
  </div>
</section>
